import React, { useEffect } from 'react';
import ChurchCalendarSection from '../../components/churchCalendar/ChurchCalendarSection';
import EditableText from '../../components/editable/EditableText';
import visitHeroBackground from '../../assets/visitus/planvisitbackground.png';
import './visit.css';

const Visit = () => {
  useEffect(() => {
    const img = new Image();
    img.src = visitHeroBackground;
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Set up intersection observer for scroll animations
    const observerOptions = {
      root: null,
      rootMargin: '-20px',
      threshold: 0.15
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll(
      '.fade-in, .slide-in-left, .slide-in-right, .slide-up'
    );
    animatedElements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      {/* Background Section */}
      <div className="background-section">
        <EditableText contentKey="visit.hero.title" tag="h1" className="background-title">
          PLAN YOUR VISIT
        </EditableText>
      </div>

      {/* Full Page Welcome Section – page-open reveal after hero */}
      <div className="welcome-message-section visit-first-content full-page">
        <div className="welcome-content">
          <EditableText contentKey="visit.welcome" tag="p" className="welcome-text">
            We can't wait to meet you! Join us for an uplifting service.
          </EditableText>
        </div>
      </div>

      {/* Address and Contact Section */}
      <div className="address-contact-container">
        {/* Address Section */}
        <div className="left-section slide-in-left">
          <h2 className="section-title">OUR ADDRESS
            <div className="divider"></div>
          </h2>
          <p className="address">
            2840 HOLME AVE, <br />
            PHILADELPHIA PA, 19152
          </p>
          <div className="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.243893683524!2d-75.0301847!3d40.0512788!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6b7bc4a5a16e7%3A0x1df77b3d7b8b1de!2s2840%20Holme%20Ave%2C%20Philadelphia%2C%20PA%2019152%2C%20USA!5e0!3m2!1sen!2sus!4v1699976149566!5m2!1sen!2sus"
              allowFullScreen
              loading="lazy"
              title="Church Location"
            ></iframe>
          </div>
        </div>

        {/* Vertical Divider */}
        <div className="vertical-line"></div>

        {/* Contact Section */}
        <div className="right-section slide-in-right">
          <h2 className="section-title">
            CONTACT US
            <div className="divider"></div>
          </h2>

          <p className="contact-details">
            <strong>Phone:</strong> (267) 984-3132 <br />
            <strong>Email:</strong> philadelphiashalemag@gmail.com
          </p>

          {/* Message Us Section */}
          <h2 className="section-title">
            MESSAGE US
            <div className="divider"></div>
          </h2>
          <div className="social-media">
            <a
              href="https://www.facebook.com/psagchurch"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg"
                alt="Facebook"
                className="social-icon"
              />
              Facebook
            </a>
            <a
              href="https://www.instagram.com/psagchurch/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                alt="Instagram"
                className="social-icon"
              />
              Instagram
            </a>
          </div>
        </div>
      </div>

      {/* Service Times Section */}
      <div className="service-times-section fade-in">
        <h3 className="service-times-title">
          OUR SERVICE TIME
          <div className="divider"></div>
        </h3>
        <div className="service-times">
          <div className="service-row">
            <div className="service-item">
              <h4 className="day">Friday</h4>
              <p className="time-details">
                Prayer Meeting: <span className="time">7:30 PM</span>
                <br />(In-Person @ Church)
              </p>
            </div>
            <div className="service-item">
              <h4 className="day">Saturday</h4>
              <p className="time-details">
                Prayer Meeting: <span className="time">6:30 PM</span>
                <br />(In-Person @ Church)
              </p>
            </div>
            <div className="service-item">
              <h4 className="day">Tuesday</h4>
              <p className="time-details">
                Prayer Meeting: <span className="time">8:00 PM</span>
                <br /> (Online)
              </p>
            </div>
            <div className="service-item">
              <h4 className="day">Sunday</h4>
              <p className="time-details">
                Sunday School: <span className="time">9:00 AM</span>
              </p>
              <p className="time-details">
                Sunday Service: <span className="time">9:45 AM</span> <br />
                (In-Church & Online)
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Church Calendar */}
      <ChurchCalendarSection
        className="fade-in visit-church-calendar"
        titleClassName="events-title"
      />
    </div>
  );
};

export default Visit;